import React, {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {p} from "@pg-design/helpers-css";
import {IModalProps, Modal} from "@pg-design/modal-module";

interface IProps extends IModalProps {
    children: React.ReactNode;
    modalHeading: React.ReactNode;
    onModalClose: () => void;
    scrollContainerRef?: RefObject<HTMLDivElement | null>;
}

export const MobileOptionsModal = (props: IProps) => {
    const {scrollContainerRef, children, className, modalHeading, ...modalProps} = props;

    return (
        <Modal {...modalProps}>
            <Modal.Header variant="bar_mini">{modalHeading}</Modal.Header>
            <Modal.Content css={p(0)} className={cx(className, scrollContainerRef && modalContentClip)}>
                {scrollContainerRef ? (
                    <div ref={scrollContainerRef} className={modalInnerScroll}>
                        {children}
                    </div>
                ) : (
                    children
                )}
            </Modal.Content>
        </Modal>
    );
};

const modalContentClip = css({
    overflow: "hidden !important"
});

const modalInnerScroll = css({
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
import React, {type RefObject} from "react";
import {css, cx} from "@panda/css";

import {p} from "@pg-design/helpers-css";
import {IModalProps, Modal} from "@pg-design/modal-module";

interface IProps extends IModalProps {
    children: React.ReactNode;
    modalHeading: React.ReactNode;
    onModalClose: () => void;
    scrollContainerRef?: RefObject<HTMLDivElement | null>;
}

export const MobileOptionsModal = (props: IProps) => {
    const {scrollContainerRef, children, className, modalHeading, ...modalProps} = props;

    return (
        <Modal {...modalProps}>
            <Modal.Header variant="bar_mini">{modalHeading}</Modal.Header>
            <Modal.Content css={p(0)} className={cx(className, scrollContainerRef && modalContentClip)}>
                {scrollContainerRef ? (
                    <div ref={scrollContainerRef} className={modalInnerScroll}>
                        {children}
                    </div>
                ) : (
                    children
                )}
            </Modal.Content>
        </Modal>
    );
};

const modalContentClip = css({
    overflow: "hidden !important"
});

const modalInnerScroll = css({
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch"
});
